import React, { useState, useEffect, useRef } from "react";
import Content from "../../../layout/content/Content";
import {
    Card,
    FormGroup,
    Modal,
    ModalBody,
    Form,
} from "reactstrap";
import {
    Button,
    Block,
    BlockHead,
    BlockTitle,
    Icon,
    Col,
    Row,
} from "../../../components/Component";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";

function UpdatePassword({...props }) {
    const [passState, setPassState] = useState(false);
    const [transData, setTransData] = useState([]);
    const [onSearch, setonSearch] = useState(true);
    const [onSearchText, setSearchText] = useState("");
    const [modal, setModal] = useState({
        add: false,
    });
    const [viewModal, setViewModal] = useState(false);
    const [detail, setDetail] = useState({});



    const [data, setData] = useState(transData);
    const [formData, setFormData] = useState({
        password: "",



    });
    const [currentPage, setCurrentPage] = useState(1);
    const [itemPerPage, setItemPerPage] = useState(3);




    const onInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        //console.log(formData)
    };

    const sortingFunc = (params) => {
        let defaultData = data;
        if (params === "asc") {
            let sortedData = [...defaultData].sort((a, b) => parseFloat(a.cloudMcatId) - parseFloat(b.cloudMcatId));
            setData([...sortedData]);
        } else if (params === "dsc") {
            let sortedData = [...defaultData].sort((a, b) => parseFloat(b.cloudMcatId) - parseFloat(a.cloudMcatId));
            setData([...sortedData]);
        }
    };

    // Changing state value when searching name
    useEffect(() => {
        if (onSearchText !== "") {
            const filteredObject = transData.filter((item) => {
                return item.mainDesc.toLowerCase().includes(onSearchText.toLowerCase());
            });
            setData([...filteredObject]);
        }
        else {
            setData([...transData]);
        }

    }, [onSearchText]);

    // function to reset the form
    const resetForm = () => {
        setFormData({
            course: "",
            institute: "",
            passingyear: "",
        });
    };

    // function to close the form modal
    const onFormCancel = () => {
        setModal({ add: false });
        resetForm();
    };

    // submit function to add a new item
    /*const onFormSubmit = (submitData) => {
        
        

        //console.log(submitData)
        setModal({ add: false });
    };*/

    const onFormSubmit = async (data) => {

        /*//console.log(data)*/

        /*setLoading(true)*/


        const sendData = {
            OrgId: Number(1),
            UserId: props.userId,
            Password: password.current,

        }
        //console.log(sendData)


        await fetch(process.env.REACT_APP_API_LINK +'api/Data/Updatepass', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    /*setLoading(false)*/
                    onFormCancel()
                    if (data === "Done") {
                        Swal.fire({
                            icon: "success",
                            title: "Done",
                            text: "Password Updated Successfully",
                            focusConfirm: false,
                        });
                       


                    }
                    else {
                        Swal.fire({
                            icon: "error",
                            title: "Error",
                            text: "Password updated Error",
                            focusConfirm: false,
                        });
                      

                    }
                })


    };


    // Get current list, pagination
    const indexOfLastItem = currentPage * itemPerPage;
    const indexOfFirstItem = indexOfLastItem - itemPerPage;
    const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

    // Change Page
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const { errors, register, handleSubmit, watch } = useForm();

    const password = useRef();
    password.current = watch("password");

    return (<>
 
                                        <Button color="primary" className="btn-icon" onClick={() => setModal({ add: true })}>
                                            <Icon name="update"></Icon> <p style={{ marginRight: 10, color: "white" }}> Update Password</p>
                                        </Button>
                

                <Modal isOpen={modal.add} toggle={() => setModal({ add: false })} className="modal-dialog-centered" size="lg">
                    <ModalBody>
                        <a
                            href="#cancel"
                            onClick={(ev) => {
                                ev.preventDefault();
                                onFormCancel();
                            }}
                            className="close"
                        >
                            <Icon name="cross-sm"></Icon>
                        </a>
                        <div className="p-2">
                            <h5 className="title">Add Details</h5>
                            <div className="mt-4">
                                <Form className="row gy-4 mt-4" onSubmit={handleSubmit(onFormSubmit)}>
                                    <Col md="6">
                                        <FormGroup>
                                            <label className="form-label" style={{ color: "#e85347" }} htmlFor="password">
                                                Password
                                            </label>
                                            <div className="form-control-wrap">
                                                <a
                                                    href="#password"
                                                    onClick={(ev) => {
                                                        ev.preventDefault();
                                                        setPassState(!passState);
                                                    }}
                                                    className={`form-icon lg form-icon-right passcode-switch ${passState ? "is-hidden" : "is-shown"}`}
                                                >
                                                    <Icon name="eye" className="passcode-icon icon-show"></Icon>

                                                    <Icon name="eye-off" className="passcode-icon icon-hide"></Icon>
                                                </a>
                                                <input
                                                    type={passState ? "text" : "password"}
                                                    id="password"
                                                    name="password"
                                                    ref={register({
                                                        required: "This field is required", minLength: {
                                                            value: 6,
                                                            message: "Password must have at least 6 characters",
                                                        },
                                                    })}
                                                    placeholder="Enter your Password"
                                                    onChange={(e) => onInputChange(e)}
                                                    className={`form-control-lg form-control ${passState ? "is-hidden" : "is-shown"}`}
                                                />
                                                {errors.password && <span className="invalid">{errors.password.message}</span>}
                                            </div>
                                        </FormGroup>
                                    </Col>
                                    <Col md="6">
                                        <FormGroup>
                                            <label className="form-label" style={{ color: "#e85347" }} htmlFor="password">
                                                Confirm Password
                                            </label>
                                            <div className="form-control-wrap">
                                                <a
                                                    href="#repassword"
                                                    onClick={(ev) => {
                                                        ev.preventDefault();
                                                        setPassState(!passState);
                                                    }}
                                                    className={`form-icon lg form-icon-right passcode-switch ${passState ? "is-hidden" : "is-shown"}`}
                                                >
                                                    <Icon name="eye" className="passcode-icon icon-show"></Icon>

                                                    <Icon name="eye-off" className="passcode-icon icon-hide"></Icon>
                                                </a>
                                                <input
                                                    type={passState ? "text" : "password"}
                                                    id="repassword"
                                                    name="repassword"
                                                    ref={register({
                                                        required: "This field is required",
                                                        validate: (value) => value === password.current || "The passwords do not match",
                                                    })}
                                                    onChange={(e) => onInputChange(e)}
                                                    placeholder="Password"
                                                    className={`form-control-lg form-control ${passState ? "is-hidden" : "is-shown"}`}
                                                />
                                                {errors.repassword && <span className="invalid">{errors.repassword.message}</span>}
                                            </div>
                                        </FormGroup>
                                    </Col>


                                    <Col size="12">
                                        <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                                            <li>
                                                <Button color="primary" size="md" type="submit">
                                                    Update
                                                </Button>
                                            </li>
                                            <li>
                                                <a
                                                    href="#cancel"
                                                    onClick={(ev) => {
                                                        ev.preventDefault();
                                                        onFormCancel();
                                                    }}
                                                    className="link link-light"
                                                >
                                                    Cancel
                                                </a>
                                            </li>
                                        </ul>
                                    </Col>
                                </Form>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>

                <Modal isOpen={viewModal} toggle={() => setViewModal(false)} className="modal-dialog-centered" size="lg">
                    <ModalBody>
                        <a
                            href="#cancel"
                            onClick={(ev) => {
                                ev.preventDefault();
                                setViewModal(false);
                            }}
                            className="close"
                        >
                            <Icon name="cross-sm"></Icon>
                        </a>
                        <div className="nk-modal-head">
                            <h4 className="nk-modal-title title">
                                Education <small className="text-primary"></small>
                            </h4>
                        </div>
                        <div className="nk-tnx-details mt-sm-3">
                            <Row className="gy-3">
                                <Col lg={6}>
                                    <span className="sub-text">ID</span>
                                    <span className="caption-text">{detail.cloudMcatId}</span>
                                </Col>
                                <Col lg={6}>
                                    <span className="sub-text">COURSE </span>
                                    <span className="caption-text text-break">{detail.mainDesc}</span>
                                </Col>
                                <Col lg={6}>
                                    <span className="sub-text">INSTITUTE</span>
                                    <span className="caption-text">{detail.columRemarks}</span>
                                </Col>
                                <Col lg={6}>
                                    <span className="sub-text">PASSING YEAR</span>
                                    <span className="caption-text">{detail.oremarks}</span>
                                </Col>

                            </Row>
                        </div>
                    </ModalBody>
                </Modal>
</>
    );
};

export default UpdatePassword;
